import request from '@/utils/request'

export function selectOrdinaryCutting(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/ordinaryCutting/selectOrdinaryCutting?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addOrdinaryCuttingSet(data) {
    return request({
        url: `api/serviceCenter/ordinaryCutting/addOrdinaryCuttingSet`,
        method: 'post',
        data,
    })
}

export function upDateOrdinaryCuttingSet(data) {
    return request({
        url: `api/serviceCenter/ordinaryCutting/upDateOrdinaryCuttingSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteOrdinaryCutting(data) {
    return request({
        url: `api/serviceCenter/ordinaryCutting/bathDeleteOrdinaryCutting`,
        method: 'post',
        data,
    })
}







